export default __webpack_public_path__ + "static/media/faulty-white.b2d98f31.svg";